export enum OtpFlowKey {
  SIGNUP = 'SIGNUP',
  LOGIN = 'LOGIN',
  FORGOT_PASSWORD_1FA = 'FORGOT_PASSWORD_1FA',
  FORGOT_PASSWORD_2FA = 'FORGOT_PASSWORD_2FA',
  PROFILE_CHANGE = 'PROFILE_CHANGE',
  PAYMENT = 'PAYMENT',
  REACTIVATION = 'REACTIVATION',
  V2A_RECEIVER = 'V2A_RECEIVER',
  CARD_CREDENTIALS = 'CARD_CREDENTIALS',
}
